export const API_ENDPOINTS = {
    // User endpoints
    LOGIN: '/users/login',
    REGISTER: '/users/register',
    REFRESH_TOKEN: '/users/refresh-token',
    FORGOT_PASSWORD: '/users/forgot-password',
    GET_CURRENT_USER: '/users/current',
    FACEBOOK_LINK: '/users/auth/facebook/link',
    FACEBOOK_LOGIN: '/users/auth/facebook/login',
    GET_USER_SERVICE_DETAILS : (userId: string) => `/user-services/user/${userId}`,
    
    // Course endpoints
    GET_COURSES: '/courses/all',
    GET_COURSE_BY_ID: (id: string) => `/courses/${id}`,
    CREATE_COURSE: '/courses',
    UPDATE_COURSE: (id: string) => `/courses/${id}`,
    DELETE_COURSE: (id: string) => `/courses/${id}`,
    GET_USER_PROFILE : (email: string) => `/users/profile/${email}`,
    UPDATE_USER_PROFILE: (email: string) => `/users/profile/${email}`,
    UPDATE_USER_PASSWORD: '/users/update-password',
    
    // Lesson endpoints
    GET_LESSONS_BY_COURSEID: (courseId: string) => `/lessons/${courseId}`,
    GET_LESSON_CONTENTS : (lessonId: string) => `/lesson-contents/lesson/${lessonId}`,
    
    // Quiz endpoints
    GET_QUIZ_QUESTIONS: (quizId: string) => `/questions/quiz/${quizId}`,
    GET_QUESTION_ANSWERS: (questionId: string) => `/questions/answer/${questionId}`,
    SAVE_ANSWER_RESULT: '/user-answers/create',

    // Exam endpoints
    GET_EXAM_AVAILABILITY: (userId: string) => `/exam-availability/user/${userId}`,
    GET_EXAM_QUESTIONS: (examId: string) => `/exam-questions/exam-details/${examId}`,
    CREATE_EXAM_RESULT: '/exam-results/create',
    GET_USER_EXAM_RESULT_DETAILS: (examId: string, userId: string) => `/user-answers/user/${userId}/exam/${examId}/details`,
    GET_EXAM_USER_RETAKE: (examId: string, userId: string) => `/exam-user-retakes/exam/${examId}/user/${userId}`,

    // Class and Student endpoints
    GET_CLASS_FEEDBACK: (classId: string, userId: string) => `/class-feedback/class/${classId}/student/${userId}`,
    GET_STUDENT_CHECK: (studentId: string) => `/classes/student-check/${studentId}`,
    GET_FEEDBACK_QUESTIONS: (feedbackId: string) => `/class-feedback-questions/feedback/${feedbackId}`,
    CREATE_FEEDBACK_RESPONSE: '/class-feedback-responses/create',
    CHECK_USER_SUBMITTED_FEEDBACK: (userId: string, feedbackId: string) => `/class-feedback/user-submitted/${userId}/${feedbackId}`,
    GET_CLASS_SHARED_FILES: (classId: string) => `/class-shared-files/class/${classId}`,
    GET_CLASS_ASSIGNMENTS: (classId: string) => `/class-assignments/class/${classId}`,
    CREATE_ASSIGNMENT_SUBMISSION: '/assignment-submissions/create',
    GET_USER_SUBMISSION: (assignmentId: string, userId: string) => `/assignment-submissions/assignment/${assignmentId}/user/${userId}`,
    UPDATE_ASSIGNMENT_SUBMISSION: (submissionId: string) => `/assignment-submissions/${submissionId}`,

    // User Progress endpoints
    GET_USER_PROGRESS_WITH_COURSE_DETAILS: (courseId: string, userId: string) => `/user-progress/with-course-details/${courseId}/${userId}`,
    CREATE_USER_PROGRESS: '/user-progress/create',

    // User Answers Dashboard
    GET_USER_ANSWERS_DASHBOARD: (userId: string) => `/user-answers/dashboard/user/${userId}`,

    // S3 File endpoints
    UPLOAD_FILE: '/lms/files/upload',
    LIST_FILES: '/lms/files/list',
    LIST_FILES_RECURSIVE: '/lms/files/list-recursive',
    DOWNLOAD_FILE: '/lms/files/download',
    DOWNLOAD_FOLDER: '/lms/files/download-folder',

}   